import {
  ReadFunction,
  CreateFunction,
  DeleteFunction,
  UpdateFunction,
  ChangeURLFunction,
  GetAllFunction,
  GetByParamsFunction,
  JsFunction,
  FileEventListener,
  DatePickerMethod,
  InputArrayFunction,
  addPagination,
  AdvanceSelectFunction,
  ServiceFunction
} from './index';

/**
 * wrapper to get the functionality from the selected methdos complex or simple
 *
 */
function getFunctionality(methodArray) {
  let jsString = '';
  // TODO this should be reworked how to combine methods possibly an hierchy
  if (methodArray.length === 2) {
    const readMethodTypes = ['get', 'getbyparams', 'getall', 'post', 'put', 'delete'];
    const readMethod = methodArray.filter((method) =>
      readMethodTypes.includes(method.methodType.toLowerCase())
    )[0];
    const changeURLMethod = methodArray.filter(
      (method) => method.methodType === 'ChangeURLFunction'
    )[0];
    if (readMethod && changeURLMethod) {
      readMethod.setNextFunction(changeURLMethod);
      jsString = readMethod.printFunction();
    } else if (readMethod && !changeURLMethod) {
      jsString = readMethod.printFunction();
    }
  } else if (methodArray.length === 1) {
    jsString = methodArray[0].printFunction();
  } else if (methodArray.lenght > 3) {
    throw new Error(
      `Js generator tries to create over two methods ${methodArray.map(
        (method) => method.methodType
      )}`
    );
  }
  return jsString;
}

/**
 * This could be simple
 *  TODO refactore it
 */
function splitCompId(functions) {
  return functions.reduce((components, method) => {
    if (components.has(method.compId)) {
      const arrayMethod = components.get(method.compId);
      arrayMethod.push(method);
      return components.set(method.compId, arrayMethod);
    }

    return components.set(method.compId, [method]);
  }, new Map());
}

/**
 * This function connect the call method to the component
 */
function addTheOnClickStructure(componentId, functionality) {
  return `document.getElementById('${componentId}').onclick = (event) => {
    event.preventDefault();
    ${functionality}};`;
}

function addOnLoadStructure(functionality) {
  return `window.onload = () => {${functionality}};`;
}


/**
 * this should be better investigated since it is confusing
 */
export function connectFunctionalityToComponents(mapCompToFunct) {
  let functionality = '';
  const onLoadElements = ['get', 'getall', 'getbyparams', 'service'];
  const onClickElements = ['post', 'put', 'delete'];
  const onLoadMethodStringArray = [];
  let foundFileInput = false;
  mapCompToFunct.forEach((methodArray, componentId) => {
    const onClickWrapper = methodArray.filter((method) =>
      onClickElements.includes(method.methodType.toLowerCase())
    );
    if (onClickWrapper.length > 0)
      functionality += addTheOnClickStructure(componentId, getFunctionality(methodArray));

    const onLoadWrapper = methodArray.filter((method) =>
      onLoadElements.includes(method.methodType.toLowerCase())
    );

    // here the functions are gathered to be wrapped afterwards
    if (onLoadWrapper.length > 0) onLoadMethodStringArray.push(getFunctionality(methodArray));

    if (methodArray.length === 1 && methodArray[0].methodType === 'ChangeURLFunction')
      functionality += addTheOnClickStructure(componentId, getFunctionality(methodArray));

    methodArray.forEach((method) => {
      if (method.methodType === 'FileEventListener') {
        if (foundFileInput === false) {
          functionality += method.createCalculateSize();
          functionality += method.createConvertBase64();
        }
        functionality += getFunctionality(methodArray);
        foundFileInput = true;
      }

      if (method.methodType === 'DatePickerMethod') {
        functionality += getFunctionality(methodArray);
      }
    });

    if (
      methodArray.length > 1 &&
      methodArray[1].methodType === 'FileEventListener' &&
      methodArray[0].methodType === 'ChangeURLFunction'
    ) {
      functionality += addTheOnClickStructure(componentId, getFunctionality([methodArray[0]]));
    }

    if (
      methodArray.length > 1 &&
      methodArray[1].methodType === 'DatePickerMethod' &&
      methodArray[0].methodType === 'ChangeURLFunction'
    ) {
      functionality += addTheOnClickStructure(componentId, getFunctionality([methodArray[0]]));
    }

    if (
      methodArray.length === 1 &&
      ['ComplexInput', 'SelectAlignEvent'].includes(methodArray[0].methodType)
    ) {
      functionality += getFunctionality([methodArray[0]]);
    }

    methodArray.forEach((method) => {
      if (method.returnType !== undefined && method.returnType.paginationList === true) {
        functionality += addPagination(method);
      }
    });
  });
  functionality += addOnLoadStructure(onLoadMethodStringArray.join(''));

  return functionality;
}

// TODO: this should be refactored as a factory pattern
function generateTheFunctionInstances(method, annotations, htmlDom, services) {
  let resolvefunction;
  switch (method.methodType) {
    case 'POST':
      resolvefunction = new CreateFunction(method, annotations, htmlDom);
      break;
    case 'PUT':
      resolvefunction = new UpdateFunction(method, annotations, htmlDom);
      break;
    case 'DELETE':
      resolvefunction = new DeleteFunction(method, annotations, htmlDom);
      break;
    case 'GET':
      resolvefunction = new ReadFunction(method, annotations, htmlDom);
      break;
    case 'ChangeURLFunction':
      resolvefunction = new ChangeURLFunction(method,annotations,htmlDom, services);
      break;
    case 'GETALL':
      resolvefunction = new GetAllFunction(method, annotations, htmlDom);
      break;
    case 'GETBYPARAMS':
      resolvefunction = new GetByParamsFunction(method, annotations, htmlDom);
      break;
    case 'FileEventListener':
      resolvefunction = new FileEventListener(method, annotations);
      break;
    case 'DatePickerMethod':
      resolvefunction = new DatePickerMethod(method);
      break;
    case 'ComplexInput':
      resolvefunction = new InputArrayFunction(method, annotations, htmlDom);
      break;
    case 'SelectAlignEvent':
      resolvefunction = new AdvanceSelectFunction(method, annotations, htmlDom);
      break;
    case 'Service':
      resolvefunction = new ServiceFunction(method, annotations,htmlDom);
      break;
    default:
      resolvefunction = new JsFunction(method, annotations);
  }
  return resolvefunction;
}

/**
 *
 */
function exportImportStatements(functionArrays) {
  let importStatements = '';
  const arrayOfImports = functionArrays.flatMap((method) =>
    method.printImportStatement().split(/(?<=;)/)
  );
  const importSet = new Set(arrayOfImports);
  importStatements = [...importSet].reduce((acc, statement) => acc + statement, '');
  return importStatements;
}

const collectCustomFunctions = (customPageJs) => {

  const customJs = customPageJs.reduce( (acc, comp) => acc + comp.customFunction, '');
  return customJs;

}

/**
 * The main function
 */
export default function generatePageJs(pageJs, annotations, htmlDom, customPageJs, services) {

  let concetradedJSAsString = '';
  concetradedJSAsString += collectCustomFunctions(customPageJs);
  
  if (pageJs.length === 0) return concetradedJSAsString;

  const functionsArray = pageJs.map((method) =>
    generateTheFunctionInstances(method, annotations, htmlDom, services)
  );

  concetradedJSAsString += exportImportStatements(functionsArray);

  // this initiate the js printing
  const compIdToFunctions = splitCompId(functionsArray);

  concetradedJSAsString += connectFunctionalityToComponents(compIdToFunctions);

  return concetradedJSAsString;
}
